import React, { useState, useEffect } from "react";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import "./pace_register.css";
import Api from "../../api";
import Select from "../Select";
import Switch from "react-switch";
import { LANGUAGES } from "../../consts";

const Pace_register = () => {
  const defaultForm = {
    program: "",
    language: "",
    level: "",
    customer_id: "",
    briefcase: "", // Added for UI filtering, not sent to API
  };
  const [formData, setFormData] = useState(defaultForm);
  const [userFound, setUserFound] = useState(null);
  const [isDeleteEnabled, setIsDeleteEnabled] = useState(false);
  const [programData, setProgramData] = useState({});

  const handleSearchUser = async () => {
    try {
      const data = await Api.User.GetById({
        customer_id: formData.customer_id,
      });
      showNotification("¡Exito!", "Usuario encontrado", "success");
      setUserFound(true);
    } catch (error) {
      showNotification("Error", error.message, "danger");
      setUserFound(false);
      setFormData({ ...defaultForm, customer_id: formData.customer_id });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Exclude briefcase from payload
      const { briefcase, ...payload } = formData;
      const data = await Api.Pace.Register(payload);
      showNotification(
        "¡Exito!",
        "Estudiante se ha registro correctamente al Pace",
        "success"
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      showNotification("Error", error.message, "danger");
    }
  };

  const handleSubmitDeletePace = async () => {
    try {
      const studentId = formData.customer_id.trim();
      if (!studentId) {
        showNotification(
          "Error",
          "El ID del estudiante no es válido",
          "danger"
        );
        return;
      }

      const response = await Api.Pace.Clear(studentId);
      showNotification(
        "¡Éxito!",
        "El Pace ha sido eliminado correctamente",
        "success"
      );

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      showNotification("Error", error.message || "Error desconocido", "danger");
    }
  };

  const fetchFilters = async (language) => {
    if (!language) return;
    try {
      const response = await Api.Pace.GetFilters(language);
      // Extract data based on structure: { data: { [language]: { ... } } }
      const data = response?.data?.[language];
      setProgramData(data || {});
    } catch (error) {
      console.error("Error fetching filters:", error);
      showNotification("Error", "No se pudieron cargar los filtros", "danger");
      setProgramData({});
    }
  };

  useEffect(() => {
    if (formData.language) {
      fetchFilters(formData.language);
      // Reset downstream fields when language changes
      setFormData((prev) => ({
        ...prev,
        briefcase: "",
        program: "",
        level: "",
      }));
    }
  }, [formData.language]);

  // Helper to format options for Select
  const formatOptions = (items) =>
    items.map((item) => ({ value: item, label: item }));

  // Get available briefcases based on language and API validation
  const getBriefcases = () => {
    if (!formData.language || !programData) return [];
    const allBriefcases = Object.keys(programData);
    // Sort naturally (e.g., P9 before P10)
    allBriefcases.sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" })
    );
    return formatOptions(allBriefcases);
  };

  // Get available programs based on language, briefcase and API validation
  const getPrograms = () => {
    if (
      !formData.language ||
      !formData.briefcase ||
      !programData[formData.briefcase]
    )
      return [];
    const allPrograms = Object.keys(programData[formData.briefcase]);
    return formatOptions(allPrograms);
  };

  // Get available levels based on language, briefcase, program and API validation
  const getLevels = () => {
    if (
      !formData.language ||
      !formData.briefcase ||
      !formData.program ||
      !programData[formData.briefcase][formData.program]
    )
      return [];
    const allLevels = [...programData[formData.briefcase][formData.program]];
    // Sort alphabetically
    allLevels.sort((a, b) => a.localeCompare(b));
    return formatOptions(allLevels);
  };

  return (
    <>
      <div className="pace-register_container">
        <h1>Registrar usuario a Pace</h1>

        <form
          className="form-register"
          onSubmit={(e) => {
            e.preventDefault();
            // If userFound is false (search mode), trigger search on Enter
            if (!userFound) {
              handleSearchUser();
            }
          }}
        >
          <div className="selectedUser">
            <h4>Ingrese la identificacion del usuario que desea registrar</h4>
            <input
              className="customer_id"
              type="text"
              id="customer_id-search"
              placeholder="Identificacion"
              value={formData.customer_id}
              onChange={(e) =>
                setFormData({ ...formData, customer_id: e.target.value })
              }
            />

            <div className="submit-buttons-container">
              <button
                className="button-search_user"
                type="button"
                onClick={handleSearchUser}
              >
                Buscar Usuario
              </button>
            </div>
          </div>
          {userFound && (
            <>
              <label>Registro del Pace</label>
              <div className="pair-container">
                <div className="customer-id_container">
                  ID del usuario
                  <input
                    className="customer_id"
                    type="number"
                    id="customer_id"
                    placeholder="Identificacion"
                    value={formData.customer_id}
                    disabled={true}
                  />
                </div>

                <div className="customer_id_type">
                  Idioma
                  <Select
                    name="language"
                    options={LANGUAGES}
                    value={LANGUAGES.find(
                      (dc) => dc.value === formData.language
                    )}
                    onChange={(e) =>
                      setFormData({ ...formData, language: e.value })
                    }
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Portafolio
                  <Select
                    name="briefcase"
                    options={getBriefcases()}
                    value={getBriefcases().find(
                      (b) => b.value === formData.briefcase
                    )}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        briefcase: e.value,
                        program: "",
                        level: "",
                      })
                    }
                    isDisabled={!formData.language}
                  />
                </div>

                <div className="customer_id_type">
                  Programa
                  <Select
                    name="program"
                    options={getPrograms()}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={getPrograms().find(
                      (p) => p.value === formData.program
                    )}
                    onChange={(e) =>
                      setFormData({ ...formData, program: e.value, level: "" })
                    }
                    isDisabled={!formData.briefcase}
                  />
                </div>
              </div>

              <div className="pair-container">
                <div className="customer-id_container">
                  Nivel
                  <Select
                    name="level"
                    options={getLevels()}
                    value={getLevels().find((l) => l.value === formData.level)}
                    onChange={(e) =>
                      setFormData({ ...formData, level: e.value })
                    }
                    isDisabled={!formData.program}
                  />
                </div>
                {/* Empty div to maintain layout balance if needed, or just leave as is */}
                <div className="customer_id_type"></div>
              </div>

              <div className="submit-buttons-container">
                <input
                  className="pace_register-button"
                  type="button"
                  value="Enviar"
                  onClick={handleSubmit}
                />
              </div>

              <div className="delete-pace-container">
                <label>Habilitar eliminación del Pace</label>
                <Switch
                  checked={isDeleteEnabled}
                  onChange={() => setIsDeleteEnabled(!isDeleteEnabled)}
                />
                <button
                  className={`delete-pace-button ${
                    isDeleteEnabled ? "enabled" : ""
                  }`}
                  type="button"
                  onClick={handleSubmitDeletePace}
                  disabled={!isDeleteEnabled}
                >
                  Borrar Pace
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default Pace_register;
